/* eslint-disable class-methods-use-this */
import Popup from './popup';

export default class LessonCoursePopup extends Popup {
  createComponent() {
    const lessonCourseReportsPopup = document.createElement(`au-${this.type}`);
    lessonCourseReportsPopup.pathQueryMap = this.pathQueryMap;
    return lessonCourseReportsPopup;
  }

  setAttributes(lessonCoursePopup) {
    lessonCoursePopup.setAttribute(
      'course-semantic-name',
      this.pathQueryMap.pathMap.content
    );
  }
}
